import React from 'react';
import UserUpdateProfileContainer from '../../../Containers/UserContainer/UserUpdateProfile';

const UserUpdateProfileScreen = () => {
  return <UserUpdateProfileContainer />;
};

export default UserUpdateProfileScreen;
